import * as React from "react";

function NetBanking(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 49 33" stroke="none"  {...props}>
      <path
        fillRule="evenodd"
        stroke="none"
        clipRule="evenodd"
        d="M3.942 0h41.116c1.086 0 2.074.455 2.786 1.189A4.103 4.103 0 0149 4.054v24.892a4.103 4.103 0 01-1.156 2.865A3.88 3.88 0 0145.058 33H3.942a3.878 3.878 0 01-2.786-1.189A4.103 4.103 0 010 28.947V4.054C0 2.94.443 1.924 1.157 1.19l-.001-.001A3.878 3.878 0 013.942 0zm41.956 29.811l-.001-.001c.215-.222.349-.528.349-.864V4.054c0-.335-.134-.641-.35-.863a1.168 1.168 0 00-.84-.358H3.942a1.17 1.17 0 00-.84.358l-.002-.002a1.24 1.24 0 00-.347.864v24.892c0 .336.134.642.35.863v.003c.212.218.51.356.839.356h41.116c.328 0 .626-.137.84-.356h.001z"
      />
      <path
        fillRule="evenodd"
        stroke="none"
        clipRule="evenodd"
        d="M15.867 13.66h17.265a.874.874 0 00.862-.888c0-.39-.244-.72-.583-.84L24.85 7.97a.842.842 0 00-.707 0l-8.629 3.994a.892.892 0 00-.49.995c.086.41.437.7.844.7zm1.079 9.672a.876.876 0 00-.863.889c0 .49.385.887.863.887h15.099a.875.875 0 00.863-.887.876.876 0 00-.863-.889h-.216v-7.108h.47c.426 0 .772-.394.772-.883-.001-.489-.346-.884-.771-.884H16.89c-.426 0-.77.395-.77.884 0 .488.344.883.77.883h.27v7.108h-.215zm1.94-7.108h2.589v7.108h-2.588v-7.108zm4.314 0h2.588v7.108H23.2v-7.108zm4.315 0h2.588v7.108h-2.588v-7.108z"
      />
    </svg>
  );
}

const MemoNetBanking = React.memo(NetBanking);
export default MemoNetBanking;
